import { type FunctionComponent, type PropsWithChildren } from 'react';
import { SHOP_BY_LOOK_LINK } from '../../../../constants/links';
import { StyledLink } from '../../../common-components/link/styled-link.component';
import ArrowNarrowRightIconIcon from '../../../svgs/untitled-ui/arrow-narrow-right.svg';
import { shopByLookSidePanel } from './shop-by-look-panel.css';

export const HomeShopByLookPanel: FunctionComponent<PropsWithChildren> = ({ children }) => {
	return (
		<div className={`flex flex-column justify-between pa4 w-100 ${shopByLookSidePanel}`}>
			<div className="flex flex-column theme-white">
				<h2 className="f2 tc tl-l mt0 mb3">Shop By Look</h2>
				<p className="tc tl-l lh-copy mt0">Discover the latest styles with rooms curated by professional designers.</p>
				<StyledLink url={SHOP_BY_LOOK_LINK} analyticsHook="hp~sbl~viewall" color="white" className="font-medium! tc tl-l">
					<span>View All</span>
					<ArrowNarrowRightIconIcon className="ml1 v-mid" />
				</StyledLink>
			</div>
			{children}
		</div>
	);
};
